import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { get } from 'lodash';
import withStyles from 'react-jss';
import classNames from 'classnames';
import Truncate from 'react-truncate';
import { Translation } from 'react-i18next';
import Scrollbar from '../Scrollbar';
import {
  getOnboardingState,
  getAuthState,
  getTenantState,
  showBrightCareersOnly,
  getCareerChoices,
} from '../../store/selectors';
import { getTenantCareers, updateUserProgress } from '../../store/actions';
import Loading from '../utility/Loading';
import ModalController from '../utility/modal/ModalController';
import FuzzySearchBar from './FuzzySearchBar';
import Spinner from '../../ASUPhotos/spinner.svg';
import HeaderWithHamburger from '../utility/HeaderWithHamburger';
import ToggleButton from '../utility/ToggleButton';
import SunIcon from '../utility/SunIcon.jsx';
import { getTop3Path } from '../../util/paths';
import { getHeaderListItems } from '../utility/headerUtil';
import BrightOutlookModal from '../utility/modal/BrightOutlookModal.jsx';

const addCareerButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    border: `2px solid white !important`,

    '&:hover': {
      border: `2px solid ${props.tenant.primary} !important`,
      color: `${props.tenant.primary} !important`,
    },
  }),
};

class CareerDegreeSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      careerList: '',
      filtered: '',
      loading: true,
      careerListLoading: false,
      usersTop3CareerIds: [],
      showBrightOutlookModal: false,
    };
  }

  componentDidMount() {
    const careerIdsArray = Object.entries(this.careerChoices).map((item) => {
      return item[1] && item[1].id;
    });

    if (this.props.careerList === '') {
      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        careerList: this.props.careerList,
        filtered: this.props.careerList,
        usersTop3CareerIds: careerIdsArray,
        loading: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const careerIdsArray = Object.entries(this.careerChoices).map((item) => {
      return item[1] && item[1].id;
    });

    if (this.props.careerList !== prevProps.careerList) {
      /* eslint-disable */
      this.setState({
        careerList: this.props.careerList,
        filtered: this.props.careerList,
        loading: false,
        usersTop3CareerIds: careerIdsArray,
      });
    }
  }

  get tenantName() {
    return this.props.tenant.name;
  }

  get onboarding() {
    return this.props.onboarding;
  }

  get educationLevel() {
    return get(this.onboarding, 'userData.user.educationLevel');
  }

  get careerOrDegree() {
    return this.props.careerOrDegree;
  }

  get careerChoices() {
    return this.props.careerChoices;
  }

  setFilteredCareerList = (val) => {
    this.setState({
      filtered: val,
    });
  };

  setCareerListLoading = (bool) => {
    if (this.state.careerListLoading !== bool) {
      this.setState({
        careerListLoading: bool,
      });
    }
  };

  backgroundPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  backgroundSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  // I have no idea why, but this is necessary in order for the titles to be truncated properly
  titleWidth = {
    width: '90%',
  };

  displayNone = {
    display: 'none',
  };

  handleCareerSearched = async () => {
    if (!this.props.onboarding.userData.userProgress['searched_career']) {
      await this.props.updateUserProgress(this.props.auth.jwtToken, {
        searched_career: true,
      });
    }
  };

  async handleAddCareer(career) {
    this.handleCareerSearched();
    this.props.history.push(
      getTop3Path(this.props.tenant, this.props.location, career.id)
    );
  }

  displayCareers = (filtered, careerListLoading) => (t) => {
    const { usersTop3CareerIds } = this.state;
    return !careerListLoading ? (
      filtered.map((career) => (
        <div className="search-result-single" key={career.id}>
          <div className="search-result-row">
            <div
              className="career-title"
              data-cy="career-title"
              style={this.titleWidth}
            >
              {this.props.careerOrDegree === 'career' ? (
                <div className="career-search-career-icon">
                  <Truncate lines={1} ellipsis="...">
                    {career.titleEn}
                  </Truncate>
                  {career.outlook ? (
                    <SunIcon
                      additionalClassName="search-row-career-icon"
                      setParentOnClick={this.setBrightOutlookModal}
                    />
                  ) : null}
                </div>
              ) : (
                <>
                  <Truncate lines={1} ellipsis="...">
                    {`${career.titleEn} - ${career.academicProgramType}`}
                  </Truncate>
                  <br />
                  {this.props.tenant.name !== 'Baobab' && (
                    <div className="degree-text-location">
                      {career.institution_info[0]?.institution_name}
                    </div>
                  )}
                </>
              )}
            </div>
            {this.props.careerOrDegree === 'career' ? (
              <button
                type="button"
                className={
                  usersTop3CareerIds.includes(career.id)
                    ? 'add-career hidden'
                    : [
                      'add-career',
                      'primary-filled',
                      this.props.classes.color,
                    ].join(' ')
                }
                style={this.backgroundPrimary}
                onClick={() => {
                  this.handleAddCareer(career);
                }}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) {
                    this.handleAddCareer(career);
                  }
                }}
              >
                {`+ ${t('Add Career')}`}
              </button>
            ) : null}
          </div>
          <div className="search-result-row">
            <Link
              to={
                this.props.careerOrDegree === 'career'
                  ? {
                    pathname: this.props.location.pathname,
                    search: `career=${encodeURIComponent(career.titleEn)}`,
                    state: { fromCareerSearch: true },
                  }
                  : {
                    pathname: this.props.location.pathname,
                    search: `degree=${encodeURIComponent(
                      career.titleEn
                    )} degreeId ${career.id}`,
                  }
              }
            >
              <p className="learn-more" style={this.colorPrimary}>
                {t('Learn more')}
              </p>
            </Link>
          </div>
        </div>
      ))
    ) : (
      <div className="spinner-container">
        <img src={Spinner} alt="Loading..." />
      </div>
    );
  };

  getListItems = () => {
    return getHeaderListItems({
      educationLevel: this.educationLevel,
      tenantName: this.tenantName,
      careerOrDegree: this.careerOrDegree,
    });
  };

  handleToggleClick = () => {
    this.props.setListToShow();
  };

  toggleFillIcon = () => {
    return (
      <SunIcon
        value={this.props.showBrightOutlookCareersOnly}
        width="25px"
        textColor={this.colorPrimary}
      />
    );
  };

  toggleClassname = 'toggle-button';

  setBrightOutlookModal = () => {
    this.setState((prevState) => ({
      showBrightOutlookModal: !prevState.showBrightOutlookModal,
    }));
  };

  render() {
    const { loading, filtered, careerListLoading } = this.state;

    if (loading) return <Loading height="100vh" />;

    return (
      <Translation>
        {(t) => (
          <>
            {this.state.showBrightOutlookModal ? (
              <BrightOutlookModal
                tenant={this.props.tenant}
                onClickParent={this.setBrightOutlookModal}
              />
            ) : null}
            <ModalController />
            <div id="career-search">
              <HeaderWithHamburger
                tenant={this.props.tenant}
                linkToDashboard={true}
                listItems={this.getListItems()}
              />
              <div className="page-body">
                <div className="search-container">
                  <div className="search-heading">
                    <h1 className="search-header">
                      {this.props.careerOrDegree === 'career'
                        ? t('Search Careers')
                        : t('Search Degrees')}
                    </h1>
                    <div
                      className="yellow-bar"
                      style={this.backgroundSecondary}
                    />
                  </div>
                  <div className="career-degree-search-toggle">
                    <FuzzySearchBar
                      inputText={this.props.inputText}
                      tenant={this.props.tenant}
                      listToSearch={this.state.careerList}
                      sendFilteredListToParent={this.setFilteredCareerList}
                      setSearchListLoadingOnParent={this.setCareerListLoading}
                      overRideStylesMag="--career-search-only"
                    />
                    {this.props.careerOrDegree === 'career' ? (
                      <ToggleButton
                        color={this.props.tenant.primary}
                        className={classNames({
                          'toggle-button-modality': true,
                        })}
                        value={this.props.showBrightOutlookCareersOnly}
                        onClick={this.handleToggleClick}
                        onLabel={[]}
                        toggleFillIcon={this.toggleFillIcon()}
                        buttonContainerStyle={this.toggleClassname}
                        ariaLabel="Turn on to display only careers with a bright outlook. Turn off to display all careers."
                      />
                    ) : null}
                  </div>
                  <Scrollbar
                    style={{ width: `100%`, height: 350 }}
                    className="search-results-container"
                    contentClassName="search-results-content"
                  >
                    <div
                      aria-live="assertive"
                      aria-atomic="true"
                      aria-relevant="all"
                      role="alert"
                    >
                      <p className="visually-hidden">
                        {this.props.careerOrDegree} Results:
                      </p>
                      {this.displayCareers(filtered, careerListLoading)(t)}
                    </div>
                  </Scrollbar>
                </div>
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const tenant = getTenantState(state);
  const showBrightOutlookCareersOnly = showBrightCareersOnly(state);
  const careerChoices = getCareerChoices(state);

  return {
    onboarding,
    auth,
    tenant,
    showBrightOutlookCareersOnly,
    careerChoices,
  };
};

const CareerDegreeSearchWithRouter = withRouter(
  connect(mapStateToProps, {
    getTenantCareers,
    updateUserProgress,
  })(CareerDegreeSearch)
);

export default withStyles(addCareerButtonStyles)(CareerDegreeSearchWithRouter);
